<template>
  <v-form ref="form" v-bind="this.$attrs">
    <v-row v-for="key in renderKeys" :key="key">
      <v-col cols="12" md="6">{{ getTitle(key) }}</v-col>
      <v-col cols="12" md="6"
        ><AutocompleteSubjectGroup v-model="subjectGroupConfig[key]" label="Bộ môn" dense hide-details outlined
      /></v-col>
    </v-row>
  </v-form>
</template>
<script>
import { get } from 'lodash'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import { AcademicLevel } from '@/plugins/api'
export default {
  components: { AutocompleteSubjectGroup },
  props: { teacher: Object, formState: Boolean },
  data: () => ({
    subjectGroupConfig: {},
    renderKeys: []
  }),
  async created() {
    await this.initData()
  },
  methods: {
    async initData() {
      const activeLevels = await AcademicLevel.fetch({ status: 'active' })
      if (Array.isArray(activeLevels) && activeLevels.length) {
        activeLevels.forEach(x => {
          this.subjectGroupConfig[`leader_${x.id}_${x.type}`] = ''
          this.subjectGroupConfig[`subLeader_${x.id}_${x.type}`] = ''
        })
      }
      if (this.teacher) {
        activeLevels.forEach(x => {
          this.subjectGroupConfig[`leader_${x.id}_${x.type}`] = get(this.teacher, `data.leader_${x.id}`, '')
          this.subjectGroupConfig[`subLeader_${x.id}_${x.type}`] = get(this.teacher, `data.subLeader_${x.id}`, '')
        })
      }
      this.renderKeys = Object.keys(this.subjectGroupConfig)
    },
    getAcademicLevel(level = '') {
      switch (level) {
        case 'primary':
          return 'Cấp Tiểu Học'
        case 'secondary':
          return 'Cấp THCS'
        case 'high':
          return 'Cấp THPT'
        default:
          return ''
      }
    },
    getTitle(key = '') {
      const keyParts = key.split('_')
      const config = keyParts[0]
      const level = keyParts[2]
      const prefix = config === 'leader' ? 'Tổ trưởng' : 'Nhóm trưởng'
      const postfix = this.getAcademicLevel(level)
      return prefix + ' ' + postfix
    },
    getData() {
      return this.subjectGroupConfig
    }
  }
}
</script>
